import React from "react";
import { classNames } from "../../helpers";
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon, FunnelIcon } from "@heroicons/react/20/solid";

export default function TwListBox(props) {
  const { children, className = "", error = false, options = [], value = "", selectClassNmae = "", selectLabelClassNmae = "", dropdownArrow = null } = props

  return (
    <Listbox value={options.find((d) => d.value === value)} onChange={(v) => {
      console.log("v", v.value);
      props.onChange(v)
      // handleFilterChange({ target: { value: v.value } })
    }}>
      <Label className="sr-only"></Label>
      <div className="relative">
        <div className={classNames("inline-flex divide-x divide-white rounded-md outline-none", selectClassNmae)}>
          <div className={classNames("inline-flex items-center gap-x-1.5 rounded-l-md bg-transparent px-3 py-2 [text-brown-coffee]", selectLabelClassNmae)}>
            {/* <CheckIcon aria-hidden="true" className="-ml-0.5 size-5" /> */}
            <p className="text-sm font-semibold">{options.find((d) => d.value === value).title}</p>
          </div>
          <ListboxButton className="inline-flex items-center rounded-l-none rounded-r-md bg-transparent p-2 outline-none hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-100">
            <span className="sr-only"></span>
            {dropdownArrow ? dropdownArrow : (<ChevronDownIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />)}
          </ListboxButton>
        </div>

        <ListboxOptions
          transition
          className="absolute right-0 z-10 mt-2 min-w-40 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
        >
          {options.map((option) => (
            <ListboxOption
              key={option.title}
              value={option}
              className="group cursor-default select-none p-4 text-sm text-gray-900 data-[focus]:bg-gray-200 data-[focus]:text-gray-900"
            >
              <div className="flex flex-col">
                <div className="flex justify-between">
                  <p className="font-normal group-data-[selected]:font-semibold ">{option.title}</p>
                  <span className="text-gray-900 group-[&:not([data-selected])]:hidden group-data-[focus]:text-gray-900">
                    <CheckIcon aria-hidden="true" className="size-5" />
                  </span>
                </div>
              </div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
